/**
 * Created by xixue on 2019/4/28.
 */
import debounce from './debounce.js'
import chat from './chat.js'
import { sendMotionEvent, sendMotionHeartBeat,isSSAI,jsBridgeForSSAI } from './utils.js'
var monitor = {
    metaData: null, // 用户数据
    questionData: null, // 补充数据，例如：题目，模块，知识点等；
    moduleData: null,
    monitorType: null, // 监控事件类型 video：视频类；question：题目
    socketChat: null, // 创建socket会话对象
    keepTimer: null, // 计时器
    faceHeartBeatTimer: null, // 心跳计时器
    keepLiveTimeCalc: 0, //保活机制计数
    noActionTimeCalc: 0, //无动作计数
    dazeTimer: null, //视频无动作计时器
    dazeTimeCalc: 0, //视频无动作计数
    videoDuration: 0,
    vjsMap: [],
    playerMap: [],
    videoData: null,
    preEventName: '',
    hasStopStudyTime: false,
    isPlayedVideo: false,
    isClose: false,
    appId: (document.body && document.body.dataset && document.body.dataset.appId) || '',
    isQimeng: false,
    noActionDialogTime: 0,//无动作计数10分钟后弹发呆弹窗
    noActionMusicUrl: '',
    /**
     * 登陆
     * @method  init
     * @param { String, String, Object }
     * @author linxiao
     */
    init: function (root, port, info) {
        let _self = this
        this.metaData = Object.assign({},{
            user_agent: navigator.userAgent,
            currentUrl : (location.href || '').split('?')[0] || '',// 将当前的url 地址发送过来，督学自习室用到
            event: info.event || 'LOGIN',
            role: info.role || 'STUDENT',
            user_id: info.user_id || 0,
            exam_else_info: info.exam_else_info || '',//试卷新参数
            account_id: info.account_id || 0,
            stage: info.stage || 20,
            learning_version: info.learning_version || 1,
            subject_id: info.subject_id || 0,
            school_id: info.school_id || 0,
            course_id: info.course_id || 0,
            lesson_id: info.lesson_id || 0,
            topic_id: info.topic_id || 0,
            flow_id: info.flow_id || 0,
            nick: info.nick || '',
            app_type: info.app_type || 1,
            client_ip: info.client_ip || '',
            question_bank_version: info.question_bank_version || ''
        });
        console.log(this.metaData)
        // 用户数据
        this.socketChat = chat; // 创建socket会话对象
        var loginMsg = this.formatSocketMsg({
            event: "LOGIN",
            role: "STUDENT"
        })
        this.socketChat.init(root, port, loginMsg, function (msg) {
            if (msg.event === 'KICKED_OUT') {
                document.onmouseover = () => {
                    location.reload()
                }
                document.onmousedown = () => {
                    location.reload()
                }
                document.onkeydown = () => {
                    location.reload()
                }
            }
            if (msg.event === 'RELOGIN') {
                sendMotionEvent('RELOGIN', _self.metaData);
            }
        });
        if(this.socketChat.socket) {

           this.timer();
        }
        //监听鼠标
        document.addEventListener('mousemove',function (event) {
            // console.log(event)
            _self.noActionTimeCalc = 0;
            _self.noActionDialogTime = 0
            _self.dazeTimeCalc = 0;
        });
        document.addEventListener('keydown',function (event) {
            // console.log(event)
            _self.noActionTimeCalc = 0;
            _self.noActionDialogTime = 0
            _self.dazeTimeCalc = 0;
        });
        //监听键盘

        if (document.querySelector('iframe')) {
            window.document.querySelector('iframe').onload = function () {
                //监听鼠标
                if (document.querySelector('iframe')) {
                    document.querySelector('iframe').contentWindow.document.onmousemove = function (event) {
                        _self.noActionTimeCalc = 0;
                        _self.noActionDialogTime = 0
                        _self.dazeTimeCalc = 0;
                    };
                    document.querySelector('iframe').contentWindow.document.onkeydown = function (event) {
                        _self.noActionTimeCalc = 0;
                        _self.noActionDialogTime = 0
                        _self.dazeTimeCalc = 0;
                    };
                }
            }
        }
        //是否是启蒙课
        this.isQimeng = sessionStorage.getItem('normalized_app_name') == 'qimeng' ? true : false
        //获取发呆弹窗音效地址
        if(!this.noActionMusicUrl){
            const hostname = window.location.hostname;
            let env = 'prod'
            if(hostname.indexOf('-test') > -1){
                env = 'test'
            }else if(hostname.indexOf('-pre') > -1){
                env = 'pre'
            }else if(hostname.indexOf('fe.dev') > -1){
                env = 'dev'
            }
            this.noActionMusicUrl = `https://statics.classba.cn/${env}/fe_public/public/audio/wrong.mp3`
        }
    },
    getModuleData: function (data) {
        this.moduleData = Object.assign({}, {
            module_type: data.module_type || 0,
            module_name: data.module_name || '',
            submodule_type: data.submodule_type || 0,
            submodule_name: data.submodule_name || '',
            tag_code_relearn_cnt: data.tag_code_relearn_cnt || 0,
        })
        if (data.tag_code) {
            this.moduleData['tag_code'] = data.tag_code
        }
        if(data.question_bank_version && data.question_vno) {
            this.moduleData['question_bank_version'] = data.question_bank_version
            this.moduleData['question_vno'] = data.question_vno
        }
        console.log('this.moduleData =', JSON.stringify(this.moduleData))
    },
    clearQuestionData: function (data) {
        this.questionData = null;
        console.log('this.questionData =', JSON.stringify(this.questionData))
    },
    //计时器
    timer: function () {
        var _self = this;
        if (this.keepTimer) {
            clearInterval(this.keepTimer)
        }
        this.keepTimer = window.setInterval(() => {
            _self.keepAlive()
            _self.noAction()
        }, 1000)
        // 情绪识别1.0心跳接口
        if (this.faceHeartBeatTimer) {
            clearInterval(this.faceHeartBeatTimer)
            this.faceHeartBeatTimer = null
        }
        this.faceHeartBeatTimer = window.setInterval(() => {
            sendMotionHeartBeat(_self.metaData)
        }, 5000)
    },
    clearCalc:function () {
        let _self = this
        _self.noActionTimeCalc = 0;
        _self.noActionDialogTime = 0
        _self.dazeTimeCalc = 0;
    },
    // 保活
    keepAlive: function () {
        var _self = this
        if (_self.keepLiveTimeCalc >= 300) {
            var timeStamp = parseInt( new Date().getTime() / 1000 )
            var keepMsg = {
                event: 'KEEPALIVE',
                role: 'STUDENT',
                client_time: timeStamp
            }
            this.socketChat.sendKeepalive(this.formatSocketMsg(keepMsg))
            _self.keepLiveTimeCalc = 0
        } else {
            _self.keepLiveTimeCalc ++
        }
    },
    // 组装会话信息
    formatSocketMsg: function (msg) {
        return Object.assign({}, this.metaData, msg);
    },
    // 长时间无动作报警
    noAction: function () {
        var _self = this
        if(_self.moduleData && _self.preEventName != 'VIDEO_PLAY') {
            _self.noActionDialogTime++;
            if (_self.noActionTimeCalc >= 301) {
                var noActionMsg = Object.assign({}, _self.moduleData, _self.questionData, {
                    event: "NO_ACTION",
                    role: "STUDENT"
                });
                this.sendEventMessage(this.formatSocketMsg(noActionMsg));
                _self.noActionTimeCalc = 0;
                // var pageLink = window.location.href;
                // pageLink.indexOf('spad.classba.cn/meta') > -1 || pageLink.indexOf('spad-pre.classba.cn/meta') > -1 || pageLink.indexOf('spad.test.classba.cn/meta') > -1 || pageLink.indexOf('me.classba.cn:8086/meta') > -1 || pageLink.indexOf('localhost:8086/meta') > -1
                if ((_self.appId == 'meta' || _self.appId == 'meta-songguo' || _self.appId == 'normalized' || _self.appId == 'normalized-songguo') && !_self.isQimeng && _self.noActionDialogTime>=600) {
                    // 如果是学习阶段并且是大模型灰度账号，触发大模型人机交互
                    if (
                        window.HWRecognizer &&
                        window.HWRecognizer.checkShow()
                    ) {
                        window.HWRecognizer.hide();
                    }
                    _self.removeNoActionDialog();
                    _self.popBackStudyDialog();
                    // _self.hasStopStudyTime = true
                    _self.stopStudyTimeFun()
                    //视频全屏时关闭视频
                    _self.stopVideoPlay()
                    // if(_self.preEventName != 'VIDEO_PAUSE' && _self.preEventName != 'VIDEO_END'){
                    //     _self.popBackStudyDialog();
                    // }else{
                    //     _self.hasStopStudyTime = true
                    //     _self.stopStudyTimeFun()
                    // }
                    _self.noActionDialogTime = 0
                }
            } else {
                _self.noActionTimeCalc++;
                // var pageLink = window.location.href;
                if ((_self.appId == 'meta' || _self.appId == 'meta-songguo' || _self.appId == 'normalized' || _self.appId == 'normalized-songguo') && !_self.isQimeng) {
                    if (_self.noActionTimeCalc >= 290 && _self.noActionTimeCalc <= 300 && _self.noActionDialogTime >= 590) {
                        if (
                            window.HWRecognizer &&
                            window.HWRecognizer.checkShow()
                        ) {
                            window.HWRecognizer.hide();
                        }
                        //视频全屏时关闭视频
                        _self.stopVideoPlay()
                        _self.popNoActionDialog(_self.noActionTimeCalc);
                        // if(_self.preEventName != 'VIDEO_PAUSE' && _self.preEventName != 'VIDEO_END'){
                        //     _self.popNoActionDialog(_self.noActionTimeCalc);
                        // }
                    }
                }
            }
        } else {
            _self.noActionTimeCalc = 0
            _self.noActionDialogTime = 0
        }
        console.log(_self.noActionDialogTime,_self.moduleData, _self.preEventName,_self.isQimeng)
    },
    /**
     * 模块开始
     * @method  moduleStart
     * @param { Object } questionData 题目数据 ;
     * @author linxiao
     */
    moduleStart: function () {
        var moduleStartMsg = Object.assign({}, this.moduleData, {
            event: "MODULE_START",
            role: "STUDENT"
        });
        this.sendEventMessage(this.formatSocketMsg(moduleStartMsg));
        sendMotionEvent('MODULE_START', this.metaData);
    },
    /**
     * 试卷完成
     * @method  examComplete
     * @param { Object } datas 传参 ;
     * @author linxiao
     */
     examComplete: function (datas) {
        var examCompleteMsg = Object.assign({}, this.moduleData, datas, {
            event: "EXAM_COMPLETE",
            role: "STUDENT"
        });
        this.sendEventMessage(this.formatSocketMsg(examCompleteMsg));
        sendMotionEvent('EXAM_COMPLETE', this.metaData);
    },
    /**
     * 取题
     * @method  getQuestion
     * @param { Object } questionData 题目数据 ;
     * @author linxiao
     */
    getQuestion: function (questionData) {
        let qTitleId = typeof questionData.question_title_id !== 'undefined'?questionData.question_title_id+'':''
        if (qTitleId == '0') {
            qTitleId = ''
        }
        this.questionData = Object.assign({}, {
            tag_code: questionData.tag_code || '0',
            main_code: questionData.main_code || '',
            question_title_id: qTitleId,
            question_ids: questionData.question_ids || [],
            question_vno: questionData.question_vno || 0,
            tag_code_relearn_cnt: questionData.tag_code_relearn_cnt || 0
        })
        if (questionData.hasOwnProperty('question_round')) {
            this.questionData.question_round = questionData.question_round;
        }
        var getQuestionMsg = Object.assign({}, this.moduleData, this.questionData, {
            event: "GET_QUESTION",
            role: "STUDENT"
        });
        // 600毫秒后发送获题事件，以防止未登录就触发，拿不到数据的问题
        setTimeout(() => {
            this.sendEventMessage(this.formatSocketMsg(getQuestionMsg));
            if (questionData.question_ids && Array.isArray(questionData.question_ids)) {
                sendMotionEvent('GET_QUESTION', this.metaData, {
                    id: questionData.question_ids.join(','),
                    emotion_uuid: questionData.emotion_uuid || '',
                });
            }
        }, 600)
    },
    getQuestionData: function (questionData) {
        this.questionData = Object.assign({}, {
            tag_code: questionData.tag_code || '0',
            main_code: questionData.main_code || '',
            question_vno: questionData.question_vno || 0,
            question_title_id: typeof questionData.question_title_id !== 'undefined'?questionData.question_title_id+'':'',
            question_ids: questionData.question_ids || [],
        })
        if (questionData.hasOwnProperty('question_round')) {
            this.questionData.question_round = questionData.question_round;
        }
    },
    /**
     * 答案输入犹豫不决 v2系统
     * @method  answerHesitate
     * @param { Object, String, Object } inputDom 输入dom ;domType 输入输入框类型： ueditor--旧版本编辑器 mathquill--新版本编辑器; msg: 补充题目数据等
     * @author linxiao
     *
     */
    answerV2Hesitate: function (inputDom, domType, msg, editCb, winDom) {
        var _monitor = this;
        var backTimes = 0, oldAnswer = '';
        var answerHesitateMsg = Object.assign({},_monitor.moduleData, _monitor.questionData, {
            event: "ANSWER_HESITATE",
            role: "STUDENT"
        });
        // console.log(_monitor)
        if (domType == 'ueditor') {
            inputDom.addListener("contentChange",function(){
                console.log('内容改变:', this.getContentLength(true));
                const mathEditorObj = editCb
                const newValue = this.getContent()

                if(mathEditorObj.isBack){
                    mathEditorObj.isBack = false
                }
                if(newValue.length < mathEditorObj.oldValue.length){
                    // console.log(newValue)
                    if(!mathEditorObj.isBack && !newValue){
                        backTimes++
                        mathEditorObj.isBack = true

                        if(backTimes >= 3){
                            var hesitateMsg = Object.assign({}, _monitor.moduleData, _monitor.questionData, answerHesitateMsg, {
                                answer: mathEditorObj.oldValue
                            })
                            _monitor.sendEventMessage(_monitor.formatSocketMsg(hesitateMsg));
                            backTimes = 0;
                        }
                        mathEditorObj.oldValue = ''
                    }
                } else {
                    mathEditorObj.oldValue = newValue
                }
            });
        }
        else if (domType == 'mathquill') {
            console.log('mathField---', editCb)
            inputDom.config({
                handlers: {
                    edit: function(mathField) {
                        console.log('this.answerHesitateMsg =', JSON.stringify(_monitor.moduleData))
                        const mathEditorObj = editCb
                        const newValue = mathField.latex()

                        if(mathEditorObj.isBack){
                            mathEditorObj.isBack = false
                        }
                        if(newValue.length < mathEditorObj.oldValue.length){
                            // console.log(newValue)
                            if(!mathEditorObj.isBack && !newValue){
                                backTimes++
                                mathEditorObj.isBack = true

                                if(backTimes >= 3){
                                    var hesitateMsg = Object.assign({}, _monitor.moduleData, _monitor.questionData, answerHesitateMsg, {
                                        answer: mathEditorObj.oldValue
                                    })
                                    _monitor.sendEventMessage(_monitor.formatSocketMsg(hesitateMsg));
                                    backTimes = 0;
                                }
                                mathEditorObj.oldValue = ''
                            }
                        } else {
                            mathEditorObj.oldValue = newValue
                        }
                        if (winDom) {
                            winDom.checkCanSubmit()
                        }
                    }
                }
            })
        }
        else if (domType == 'input' || domType == 'textarea') {
            const block = inputDom
            const mathEditorObj = editCb
            const type = mathEditorObj.inputType
            // console.log({inputDom, domType, msg, editCb, winDom})
            if(block.isBack){
                block.isBack = false
            }

            if(type === 'deleteContentBackward'){
                console.log({inputDom, domType, msg, editCb, winDom},!block.isBack && !block.text,block.backTimes)
                if(!block.isBack && !block.text){
                    block.backTimes++
                    console.log({block},block.backTimes)
                    block.isBack = true
                    if(block.backTimes >= 3){
                        var hesitateMsg = Object.assign({}, answerHesitateMsg, {
                            answer: block.oldValue
                        })
                        _monitor.sendEventMessage(_monitor.formatSocketMsg(hesitateMsg));

                        block.backTimes = 0
                    }
                }
            } else {
                block.oldValue = block.text
            }

            if (winDom) {
                winDom.checkCanSubmit()
            }
        }
        else if (domType == 'kity') {
            console.log({editCb})
            inputDom.func = function(e){
                const mathEditorObj = editCb
                const newValue = inputDom.kfe.execCommand('get.source').replace(/\\placeholder/g,"")
                console.log('-----------------------');
                console.log({newValue})
                if(mathEditorObj.isBack){
                    mathEditorObj.isBack = false
                }
                console.log('content.is.empty',inputDom.kfe.execCommand('content.is.empty'))
                if(newValue.length <= mathEditorObj.oldValue.length){
                    // console.log('backTimes', backTimes);

                    if(!mathEditorObj.isBack && inputDom.kfe.execCommand('content.is.empty')){
                        backTimes++
                        mathEditorObj.isBack = true

                        if(backTimes >= 3){
                            var hesitateMsg = Object.assign({}, _monitor.moduleData, _monitor.questionData, answerHesitateMsg, {
                                answer: mathEditorObj.oldValue
                            })
                            _monitor.sendEventMessage(_monitor.formatSocketMsg(hesitateMsg));
                            backTimes = 0;
                        }
                        mathEditorObj.oldValue = ''
                    }
                } else {
                    mathEditorObj.oldValue = newValue
                }
            }
            inputDom.addEventListener('message',inputDom.func,false);
        }
    },
    /**
     * 答案输入犹豫不决 小学语文 小学数学
     * @method  answerHesitate
     * @param { Object, String, Object } inputDom 输入dom ;domType 输入输入框类型： ueditor--旧版本编辑器 mathquill--新版本编辑器; msg: 补充题目数据等
     * @author linxiao
     *
     */
    answerHesitate: function (inputDom, domType, msg, editCb, winDom) {
        var _monitor = this;
        var backTimes = 0, oldAnswer = '';
        var answerHesitateMsg = Object.assign({},_monitor.moduleData, _monitor.questionData, {
            event: "ANSWER_HESITATE",
            role: "STUDENT"
        });
        // console.log(_monitor)
        if (domType == 'ueditor') {
            inputDom.addListener("contentChange",function(){
                console.log('内容改变:', this.getContentLength(true));
                const mathEditorObj = editCb
                const newValue = this.getContent()

                if(mathEditorObj.isBack){
                    mathEditorObj.isBack = false
                }
                if(newValue.length < mathEditorObj.oldValue.length){
                    // console.log(newValue)
                    if(!mathEditorObj.isBack && !newValue && !mathEditorObj.isClear){
                        backTimes++
                        mathEditorObj.isBack = true

                        if(backTimes >= 3){
                            var hesitateMsg = Object.assign({}, _monitor.moduleData, _monitor.questionData, answerHesitateMsg, {
                                answer: mathEditorObj.oldValue
                            })
                            _monitor.sendEventMessage(_monitor.formatSocketMsg(hesitateMsg));
                            backTimes = 0;
                        }
                        mathEditorObj.oldValue = ''
                    }
                } else {
                    mathEditorObj.oldValue = newValue
                }
            });
        }
        else if (domType == 'mathquill') {
            console.log('mathField---', editCb)
            inputDom.config({
                handlers: {
                    edit: function(mathField) {
                        console.log('this.answerHesitateMsg =', JSON.stringify(_monitor.moduleData))
                        const mathEditorObj = editCb
                        const newValue = mathField.latex()

                        if(mathEditorObj.isBack){
                            mathEditorObj.isBack = false
                        }
                        if(newValue.length < mathEditorObj.oldValue.length){
                            // console.log(newValue)
                            if(!mathEditorObj.isBack && !newValue){
                                backTimes++
                                mathEditorObj.isBack = true

                                if(backTimes >= 3){
                                    var hesitateMsg = Object.assign({}, _monitor.moduleData, _monitor.questionData, answerHesitateMsg, {
                                        answer: mathEditorObj.oldValue
                                    })
                                    _monitor.sendEventMessage(_monitor.formatSocketMsg(hesitateMsg));
                                    backTimes = 0;
                                }
                                mathEditorObj.oldValue = ''
                            }
                        } else {
                            mathEditorObj.oldValue = newValue
                        }
                        if (winDom) {
                            winDom.checkCanSubmit()
                        }
                    }
                }
            })
        }
        else if (domType == 'input' || domType == 'textarea') {
            const block = inputDom
            const mathEditorObj = editCb
            const type = mathEditorObj.inputType
            // console.log(text)
            // console.log(e)
            if(block.isBack){
                block.isBack = false
            }

            if(type === 'deleteContentBackward'){
                if(!block.isBack && !block.text){
                    block.backTimes++
                    console.log({block})
                    block.isBack = true
                    if(block.backTimes >= 3){
                        var hesitateMsg = Object.assign({}, answerHesitateMsg, {
                            answer: block.oldValue
                        })
                        _monitor.sendEventMessage(_monitor.formatSocketMsg(hesitateMsg));

                        block.backTimes = 0
                    }
                }
            } else {
                block.oldValue = block.text
            }

            if (winDom) {
                winDom.checkCanSubmit()
            }
        }
        else if (domType == 'kity') {
            console.log({editCb})
            inputDom.func = function(e){
                const mathEditorObj = editCb
                const newValue = inputDom.kfe.execCommand('get.source').replace(/\\placeholder/g,"")
                console.log('-----------------------');
                console.log({newValue})
                if(mathEditorObj.isBack){
                    mathEditorObj.isBack = false
                }
                console.log('content.is.empty',inputDom.kfe.execCommand('content.is.empty'))
                if(newValue.length <= mathEditorObj.oldValue.length){
                    // console.log('backTimes', backTimes);

                    if(!mathEditorObj.isBack && inputDom.kfe.execCommand('content.is.empty')){
                        backTimes++
                        mathEditorObj.isBack = true

                        if(backTimes >= 3){
                            var hesitateMsg = Object.assign({}, _monitor.moduleData, _monitor.questionData, answerHesitateMsg, {
                                answer: mathEditorObj.oldValue
                            })
                            _monitor.sendEventMessage(_monitor.formatSocketMsg(hesitateMsg));
                            backTimes = 0;
                        }
                        mathEditorObj.oldValue = ''
                    }
                } else {
                    mathEditorObj.oldValue = newValue
                }
            }
            inputDom.addEventListener('message',inputDom.func,false);
        } else if (domType == 'maths') {
            var hesitateMsg = Object.assign({}, answerHesitateMsg, {
                answer: msg
            })
            _monitor.sendEventMessage(_monitor.formatSocketMsg(hesitateMsg));
        }
    },
    /**
     * 选项犹豫不决&鼠标滑过选项
     * @method  optionHesitate
     * @param { Object } questionData 题目数据 ;
     * @author linxiao
     * @version v2学习系统
     */
    optionV2Hesitate: function (msg) {
        var optionV2HesitateMsg = Object.assign({}, this.moduleData, this.questionData, {
            event: "CHOICE_QUESTION_HESITATE",
            role: "STUDENT",
            pre_option: msg.pre_option || '',
            current_option: msg.current_option || ''
        });
        this.sendEventMessage(this.formatSocketMsg(optionV2HesitateMsg));
    },
    /**
     * 选项犹豫不决&鼠标滑过选项
     * @method  optionV2Over
     * @param { Object } questionData 题目数据 ;
     * @author linxiao
     * @version v2学习系统
     */
    optionV2Over: function (msg) {
        console.log(msg)
        var optionV2OverMsg = Object.assign({}, this.moduleData, this.questionData, {
            event: "MOUSE_OVER_CHOICE_OPTION",
            role: "STUDENT",
            option: msg.option || ''
        });
        this.sendEventMessage(this.formatSocketMsg(optionV2OverMsg));
    },
    /**
     * 选项犹豫不决&鼠标滑过选项
     * @method  optionHesitate
     * @param { Object } questionData 题目数据 ;
     * @author linxiao
     * @version
     */
    optionHesitate: function (optionDom, msg) {

    },
    /**
     * 选项犹豫不决&鼠标滑过选项
     * @method  optionOver
     * @param { Object } questionData 题目数据 ;
     * @author linxiao
     * @version v1学习系统
     */
    optionOver: debounce(function (msg) {
        console.log(msg)
        var optionV2OverMsg = Object.assign({}, this.moduleData, this.questionData, {
            event: "MOUSE_OVER_CHOICE_OPTION",
            role: "STUDENT",
            option: msg.option || ''
        });
        this.sendEventMessage(this.formatSocketMsg(optionV2OverMsg));
    }, 500, true),
    /**
     * 查看解析
     * @method  getAnalyse
     * @param null ;
     * @author linxiao
     */
    getAnalyse: function (msg) {
        var getAnalyseMsg = Object.assign({}, this.moduleData, this.questionData, {
            event: "GET_ANALYSIS",
            role: "STUDENT",
            if_active_check: msg.if_active_check || 0
        });
        this.sendEventMessage(this.formatSocketMsg(getAnalyseMsg));
        if (msg.question_ids && typeof msg.question_ids === 'string') {
            setTimeout(() => {
                sendMotionEvent('GET_ANALYSIS', this.metaData, {
                    id: msg.question_ids,
                    emotion_uuid: msg.emotion_uuid || '',
                });
            }, 2000);
        }
    },
    /**
     * 下一步（视频跳过不学事件同时触发）
     * @method  nextStep
     * @param { Object } msg 答题结果及能力值信息等 ;
     * @author linxiao
     */
    nextStep: function (msg) {
        var _self = this;
        console.log('nextSrep----', _self.vjsMap)
        _self.vjsMap.map(function (vjs, i) {
            console.log(i, vjs)
            if (vjs.isClickVideoBtn) {
                if (vjs.is_played && vjs.remainingTime() > (vjs.duration() * 2 / 3)) {
                    const msg = Object.assign({}, _self.moduleData, _self.questionData, {
                        event: "VIDEO_PLAYED_SKIP",
                        role: "STUDENT",
                        video_id: vjs.video_id || '',
                        video_type: vjs.video_type || '',
                        video_url: vjs.video_url || '',
                        tag_code: _self.videoData.tag_code || '',
                        video_duration: vjs.duration() || 0,
                        event_begin: vjs.currentTime()
                    });
                    _self.sendEventMessage(_self.formatSocketMsg(msg));
                    vjs.is_played = false
                } else if (!vjs.is_played){
                    const msg = Object.assign({}, _self.moduleData, _self.questionData, {
                        event: "VIDEO_UNPLAYED_SKIP",
                        role: "STUDENT",
                        video_id: vjs.video_id || '',
                        video_type: vjs.video_type || '',
                        video_url: vjs.video_url || '',
                        tag_code: _self.videoData.tag_code || '',
                        video_duration: vjs.duration() || 0,
                        event_begin: vjs.currentTime()
                    });
                    _self.sendEventMessage(_self.formatSocketMsg(msg));
                    vjs.is_played = false
                }
            }
            vjs.reset()
        })
        this.clearVjsMap();
        this.clearQuestionData();
        this.videoData = null;
        this.isClose = false;

    },
    nextStepV2: function (msg) {
        var _self = this;
        console.log('nextSrep----', _self.playerMap)
        _self.playerMap.map(function (vjs, i) {
            console.log(i, vjs)
            if (vjs.is_click) {
                if (vjs.is_played && vjs.remain_time > (vjs.video_duration * 2 / 3)) {
                    const msg = Object.assign({}, _self.moduleData, _self.questionData, {
                        event: "VIDEO_PLAYED_SKIP",
                        role: "STUDENT",
                        video_id: vjs.video_id || '',
                        video_type: vjs.video_type || '',
                        video_url: vjs.video_url || '',
                        tag_code: _self.videoData.tag_code || '',
                        video_duration: vjs.video_duration || 0,
                        event_begin: vjs.event_begin
                    });
                    _self.sendEventMessage(_self.formatSocketMsg(msg));
                } else if (!vjs.is_played){
                    const msg = Object.assign({}, _self.moduleData, _self.questionData, {
                        event: "VIDEO_UNPLAYED_SKIP",
                        role: "STUDENT",
                        video_id: vjs.video_id || '',
                        video_type: vjs.video_type || '',
                        video_url: vjs.video_url || '',
                        tag_code: _self.videoData.tag_code || '',
                        video_duration: vjs.video_duration || 0,
                        event_begin: vjs.event_begin
                    });
                    _self.sendEventMessage(_self.formatSocketMsg(msg));
                }
            }
        })
        this.clearVjsMap();
        this.clearQuestionData();
        this.videoData = null;
        this.isClose = false;
        this.playerMap = []

    },
    /**
     * 提交答案（视频跳过不学事件同时触发）
     * @method  submitAnswer
     * @param { Object } msg 答题结果及能力值信息等 ;
     * @author linxiao
     */
    submitAnswer: function (msg) {
        var _self = this;
        // _self.vjsMap.map(function (vjs, i) {
        //     console.log(i, vjs)
        //     if (vjs.is_played && vjs.remainingTime() > (vjs.duration() * 2 / 3)) {
        //         const msg = Object.assign({}, _self.moduleData, _self.questionData, {
        //             event: "VIDEO_PLAYED_SKIP",
        //             role: "STUDENT",
        //             video_id: vjs.video_id || '',
        //             video_type: vjs.video_type || '',
        //             video_url: vjs.video_url || '',
        //             video_duration: vjs.duration(),
        //             event_begin: vjs.currentTime()
        //         });
        //         _self.sendEventMessage(_self.formatSocketMsg(msg));
        //     } else if (!vjs.is_played){
        //         const msg = Object.assign({}, _self.moduleData, _self.questionData, {
        //             event: "VIDEO_UNPLAYED_SKIP",
        //             role: "STUDENT",
        //             video_id: vjs.video_id || '',
        //             video_type: vjs.video_type || '',
        //             video_url: vjs.video_url || '',
        //             video_duration: vjs.duration(),
        //             event_begin: vjs.currentTime()
        //         });
        //         _self.sendEventMessage(_self.formatSocketMsg(msg));
        //     }
        // })
        var qTitleId = typeof msg.question_title_id !== 'undefined' ? msg.question_title_id + '' : ''
        if (qTitleId == '0') {
            qTitleId = ''
        }
        var submitQuestionMsg = Object.assign({}, this.moduleData, this.questionData, {
            event: "SUBMIT_ANSWER",
            role: "STUDENT",
            answers: msg.answers || {},
            q_forms: msg.q_forms || 0,
            q_difficulty: msg.q_difficulty || 0,
            tag_code: msg.tag_code || '0',
            main_code: msg.main_code || '',
            question_title_id: qTitleId,
            question_ids: msg.question_ids || [],
        });
        this.sendEventMessage(this.formatSocketMsg(submitQuestionMsg));
        if (msg.question_ids && Array.isArray(msg.question_ids)) {
            sendMotionEvent('SUBMIT_ANSWER', this.metaData, {
                id: msg.question_ids.join(',') ,
                emotion_uuid: msg.emotion_uuid || '',
            })
        }
    },
    clearVjsMap: function () {
        this.vjsMap = [];
        if (this.dazeTimer) {
            clearInterval(this.dazeTimer);
        }
        this.playerMap = []
        console.log(this.vjsMap)
    },
    /**
     * 模块结束
     * @method  moduleEnd
     * @param null ;
     * @author linxiao
     */
    moduleEnd: function () {
        var moduleEndMsg = Object.assign({}, this.moduleData, {
            event: "MODULE_END",
            role: "STUDENT"
        });
        this.sendEventMessage(this.formatSocketMsg(moduleEndMsg));
        this.moduleData = null;
    },
    /**
     * 知识点结束
     * @method tagCodeEnd
     * @param null ;
     * @author liyongliang
     */
    tagCodeEnd: function () {
        var moduleEndMsg = Object.assign({}, this.moduleData, {
            event: "TAG_CODE_END",
            role: "STUDENT"
        });
        this.sendEventMessage(this.formatSocketMsg(moduleEndMsg));
        this.moduleData = null;
    },
    setVjs:function (vjs) {
        var result = this.vjsMap.some(item=>{
            if(item.player_type == vjs.player_type){
                return true
            }
        })
        if(!result){ // 如果不存在
            this.vjsMap.push(vjs)
        } else {
            console.log(this.vjsMap)
            this.vjsMap = this.vjsMap.filter((item =>{return item.player_type !== vjs.player_type}))
            this.vjsMap.push(vjs)
        }
    },
    getVideoData: function (videoData) {
        this.videoData = {
            tag_code: videoData.tag_code || '',
            video_id: videoData.video_id || '',
            video_type: videoData.video_type || '',
            video_url: videoData.video_url || '',
        }
    },
    /**
     * 监听视频事件
     * @method  videoMonitorEvent
     * @param { Object, Object } vjs 视频组件；videoData 视频相关信息 ;
     * @author linxiao
     */
    videoMonitorEvent: function (vjs, videoData) {
        var _self = this;
        this.isClose = false
        var result = this.vjsMap.some(item=>{
            if(item.player_type == vjs.player_type){
                return true
            }
        })
        var vmap = this.vjsMap
        console.log({result,vmap}) // 如果arr数组对象中,就会返回true，否则返回false
        if(!result){ // 如果不存在
            var isSeeked = false;
            var isSeeking = false;
            var lastTime = 0,
                lastDateTime = new Date().getTime();
            var duration = vjs.duration();
            if(!this.videoData) {
                vjs.video_id = videoData.video_id || '';
                vjs.video_type = videoData.video_type || '';
                vjs.video_url = videoData.video_url
            } else {
                vjs.video_id = this.videoData.video_id || '';
                vjs.video_type = this.videoData.video_type || '';
                vjs.video_url = this.videoData.video_url
            }
            var videoMsgData = null;
            // if (videoData.tag_code) {
            //     videoMsgData = {
            //         tag_code: videoData.tag_code || '',
            //         video_id: videoData.video_id || '',
            //         video_type: videoData.video_type || '',
            //         video_url: videoData.video_url || '',
            //     }
            // } else {
            //     videoMsgData = {
            //         video_id: videoData.video_id || '',
            //         video_type: videoData.video_type || '',
            //         video_url: videoData.video_url || '',
            //     }
            // }
            this.videoDuration = duration;
            vjs.on("playing", function(e) {
                var _player = this
                this.addClass('playing')
                vjs.is_played = true;
                clearInterval(_self.dazeTimer);
                _self.dazeTimeCalc = 0;
                if (_player.isDone) {
                    isSeeked = false;
                    _player.isDone = false;
                }
                if(!isSeeked) {
                    var videoPlayMsg = Object.assign({}, _self.moduleData, _self.questionData, {
                        event: "VIDEO_PLAY",
                        role: "STUDENT",
                        tag_code: videoData.tag_code || '',
                        video_id: videoData.video_id || '',
                        video_type: videoData.video_type || '',
                        video_url: _player.video_url || '',
                        event_begin: _player.currentTime(),
                        video_duration: duration || _player.duration() || 0
                    },_self.videoData, videoMsgData);
                    console.log(videoPlayMsg, _self.videoData)
                    _self.sendEventMessage(_self.formatSocketMsg(videoPlayMsg));
                    _self.isPlayedVideo = true
                }

            });
            vjs.on('timeupdate', function (e) {
                if(!isSeeking){
                    let dis = new Date().getTime() - lastDateTime
                    if(dis >= 1000){
                        lastTime = this.currentTime().toFixed(1)
                        lastDateTime = new Date().getTime()
                        // console.log("isSeeking = " + lastTime)
                    }
                }
                _self.noActionTimeCalc = 0;
                _self.noActionDialogTime = 0
            })
            vjs.on('seeking', function (e) {
                isSeeking = true
            })
            vjs.on('seeked', function (e) {
                let _player = this, msg = {}
                let disTime = this.currentTime().toFixed(1) - lastTime
                console.log(this.currentTime().toFixed(1), lastTime)
                if(disTime >= 0 && this.currentTime().toFixed(1)!= 0){//快进

                    msg = Object.assign({}, _self.moduleData, _self.questionData, {
                        event: 'VIDEO_DRAG',
                        role: "STUDENT",
                        tag_code: videoData.tag_code || '',
                        video_id: videoData.video_id || '',
                        video_type: videoData.video_type || '',
                        video_url: videoData.video_url || '',
                        video_duration: duration || _player.duration() || 0,
                        event_begin: parseFloat(lastTime),
                        event_end: _player.currentTime()
                    },_self.videoData, videoMsgData)
                }else{//回看
                    // console.log("回看")
                    msg = Object.assign({}, _self.moduleData, _self.questionData, {
                        event: 'VIDEO_BACK',
                        role: "STUDENT",
                        tag_code: videoData.tag_code || '',
                        video_id: videoData.video_id || '',
                        video_type: videoData.video_type || '',
                        video_url: videoData.video_url || '',
                        video_duration: duration || _player.duration() || 0,
                        event_begin: parseFloat(lastTime),
                        event_end: _player.currentTime()
                    },_self.videoData, videoMsgData)
                }
                _self.sendEventMessage(_self.formatSocketMsg(msg))
                lastTime = _player.currentTime().toFixed(1)
                isSeeked = true
                isSeeking = false

                setTimeout(function () {
                    console.log('this.scrubbing()----',_player.scrubbing())
                    isSeeked = false
                }, 200)

            })
            vjs.on("pause", function(e) {
                var playObj = this;
                let remainingTime = this.remainingTime()

                if(!this.scrubbing() && remainingTime > 0.1 && !_self.isClose) {
                    console.log('pause=remainingTime==', remainingTime)
                    let currentTime = playObj.currentTime();
                    console.log({currentTime});
                    var videoPauseMsg = Object.assign({},  _self.moduleData, _self.questionData, {
                        event: "VIDEO_PAUSE",
                        role: "STUDENT",
                        tag_code: videoData.tag_code || '',
                        video_id: videoData.video_id || '',
                        video_type: videoData.video_type || '',
                        video_url: videoData.video_url || '',
                        event_begin: playObj.currentTime(),
                        video_duration: duration || playObj.duration() || 0
                    },_self.videoData, videoMsgData)
                    _self.sendEventMessage(_self.formatSocketMsg(videoPauseMsg))
                    if (_self.dazeTimer) {
                        clearInterval(_self.dazeTimer);
                    }
                    _self.dazeTimer = setInterval(function() {
                        var dazeTime = _self.dazeTimeCalc;
                        console.log({dazeTime})
                        if (_self.dazeTimeCalc >= 180) {
                            let dazeMsg = Object.assign({},  _self.moduleData, _self.questionData, {
                                event: "VIDEO_PAUSE_DAZE",
                                role: "STUDENT",
                                tag_code: videoData.tag_code || '',
                                video_id: videoData.video_id || '',
                                video_type: videoData.video_type || '',
                                video_url: videoData.video_url || '',
                                video_duration: duration || playObj.duration() || 0,
                                event_begin: playObj.currentTime()
                            }, _self.videoData,videoMsgData);
                            _self.sendEventMessage(_self.formatSocketMsg(dazeMsg))
                            _self.dazeTimeCalc = 0;
                        } else {
                            ++_self.dazeTimeCalc;
                        }
                    }, 1000);
                    //
                }
            });
            vjs.on("ended", function(e) {
                e.stopPropagation();
                // console.log('ended===', this.currentTime())
                var playObj = this;
                var videoEndMsg = Object.assign({},  _self.moduleData, _self.questionData, {
                    event: "VIDEO_END",
                    role: "STUDENT",
                    tag_code: videoData.tag_code || '',
                    video_id: videoData.video_id || '',
                    video_type: videoData.video_type || '',
                    video_url: videoData.video_url || '',
                    event_begin: this.currentTime(),
                    video_duration: duration || playObj.duration() || 0
                },_self.videoData, videoMsgData)
                _self.sendEventMessage(_self.formatSocketMsg(videoEndMsg))
                if (_self.dazeTimer) {
                    clearInterval(_self.dazeTimer);
                }
                _self.dazeTimer = setInterval(function() {
                    var dazeTime = _self.dazeTimeCalc;
                    console.log({dazeTime})
                    if (_self.dazeTimeCalc >= 180) {
                        let dazeMsg = Object.assign({},  _self.moduleData, _self.questionData, {
                            event: "VIDEO_END_DAZE",
                            role: "STUDENT",
                            tag_code: videoData.tag_code || '',
                            video_id: videoData.video_id || '',
                            video_type: videoData.video_type || '',
                            video_url: videoData.video_url || '',
                            video_duration: duration || playObj.duration() || 0,
                            event_begin: playObj.currentTime()
                        }, _self.videoData,videoMsgData);
                        _self.sendEventMessage(_self.formatSocketMsg(dazeMsg))
                        _self.dazeTimeCalc = 0;
                    } else {
                        ++_self.dazeTimeCalc;
                    }
                }, 1000);
                lastTime = 0;
                playObj.isDone = true
            });
            this.vjsMap.push(vjs)
        } else {
            console.log(this.vjsMap)
            this.vjsMap = this.vjsMap.filter((item =>{return item.player_type !== vjs.player_type}))
            this.vjsMap.push(vjs)
        }

    },
    /**
     * 关闭视频
     * @method  videoMonitorEvent
     * @param { Object, Object } vjs 视频组件；videoData 视频相关信息 ;
     * @author linxiao
     */
    closeVideo: function (vjs, videoData) {
        console.log(vjs)
        var _self = this;
        if(_self.dazeTimer) {
            clearInterval(_self.dazeTimer);
        }
        const msg = Object.assign({}, this.moduleData, this.questionData, {
            event: "VIDEO_CLOSE",
            role: "STUDENT",
            tag_code: videoData.tag_code || '',
            video_id: videoData.video_id || '',
            video_type: videoData.video_type || '',
            video_url: videoData.video_url || '',
            video_duration: vjs.duration() || 0,
            event_begin: vjs.currentTime()
        }, _self.videoData);
        this.sendEventMessage(this.formatSocketMsg(msg));
        this.isClose = true
        vjs.pause()
        setTimeout(()=>{
            this.isClose = false
        }, 200)
    },
    closeVideoV2: function (vjs, videoData) {
        var _self = this;
        if(_self.dazeTimer) {
            clearInterval(_self.dazeTimer);
        }
        const msg = Object.assign({}, this.moduleData, this.questionData, {
            event: "VIDEO_CLOSE",
            role: "STUDENT",
            tag_code: videoData.tag_code || '',
            video_id: videoData.video_id || '',
            video_type: videoData.video_type || '',
            video_url: videoData.video_url || '',
            video_duration: vjs.duration() || 0,
            event_begin: vjs.currentTime()
        }, _self.videoData);
        this.sendEventMessage(this.formatSocketMsg(msg));
        var result = this.playerMap.some(item=>{
            if(item.player_type == vjs.player_type){
                return true
            }
        })
        if(!result){ // 如果不存在
            this.playerMap.push({
                remain_time: vjs.remainingTime(),
                video_id: videoData.video_id || '',
                video_type: videoData.video_type || '',
                video_url: videoData.video_url || '',
                tag_code: videoData.tag_code || '',
                player_type: vjs.player_type,
                video_duration: vjs.duration() || 0,
                is_click: vjs.isClickVideoBtn,
                is_played: vjs.is_played,
                event_begin: vjs.currentTime()
            })
        } else {
            console.log(this.playerMap)
            this.playerMap = this.playerMap.filter((item =>{return item.player_type !== vjs.player_type}))
            this.playerMap.push({
                remain_time: vjs.remainingTime(),
                video_id: videoData.video_id || '',
                video_type: videoData.video_type || '',
                video_url: videoData.video_url || '',
                tag_code: videoData.tag_code || '',
                video_duration: vjs.duration() || 0,
                is_click: vjs.isClickVideoBtn,
                is_played: vjs.is_played,
                player_type: vjs.player_type,
                event_begin: vjs.currentTime()
            })
        }
        console.log(this.playerMap)
        this.isClose = true
        vjs.pause()
        setTimeout(()=>{
            this.isClose = false
        }, 200)
    },
    closeVideoV3: function (vjs, videoData) {
        var _self = this;
        if(_self.dazeTimer) {
            clearInterval(_self.dazeTimer);
        }
        const msg = Object.assign({}, this.moduleData, this.questionData, {
            event: "VIDEO_CLOSE",
            role: "STUDENT",
            tag_code: videoData.tag_code || '',
            video_id: videoData.video_id || '',
            video_type: videoData.video_type || '',
            video_url: videoData.video_url || '',
            video_duration: vjs.duration() || 0,
            event_begin: vjs.currentTime()
        }, _self.videoData);
        this.sendEventMessage(this.formatSocketMsg(msg));
        var result = this.playerMap.some(item=>{
            if(item.player_type == vjs.player_type){
                return true
            }
        })
        if(!result){ // 如果不存在
            this.playerMap.push({
                remain_time: vjs.remainingTime(),
                video_id: videoData.video_id || '',
                video_type: videoData.video_type || '',
                video_url: videoData.video_url || '',
                tag_code: videoData.tag_code || '',
                player_type: vjs.player_type,
                video_duration: vjs.duration() || 0,
                is_click: vjs.isClickVideoBtn,
                is_played: vjs.is_played,
                event_begin: vjs.currentTime()
            })
        } else {
            console.log(this.playerMap)
            this.playerMap = this.playerMap.filter((item =>{return item.player_type !== vjs.player_type}))
            this.playerMap.push({
                remain_time: vjs.remainingTime(),
                video_id: videoData.video_id || '',
                video_type: videoData.video_type || '',
                video_url: videoData.video_url || '',
                tag_code: videoData.tag_code || '',
                video_duration: vjs.duration() || 0,
                is_click: vjs.isClickVideoBtn,
                is_played: vjs.is_played,
                player_type: vjs.player_type,
                event_begin: vjs.currentTime()
            })
        }
        console.log(this.playerMap)
        this.isClose = true
        vjs.pause()
        setTimeout(()=>{
            this.isClose = false
        }, 600)
    },
    /**
     * 查看报告
     * @method  getReport
     * @param { Object } msg 报告 ;
     * @author linxiao
     */
    getReport: function (msg) {
        var reportData = Object.assign({}, {
            module_type: msg.module_type || 0,
            module_name: msg.module_name || '',
            submodule_type: msg.submodule_type || 0,
            submodule_name: msg.submodule_name || '',
            report_url: msg.report_url || '',
            report_depth: msg.report_depth || 4
        })
        var getReportDataMsg = Object.assign({}, this.moduleData, reportData, {
            event: "GET_REPORT",
            role: "STUDENT"
        });
        this.sendEventMessage(this.formatSocketMsg(getReportDataMsg));
    },
    /**
     * 学习机原生播放器-播放视频
     * @method  spadVideoPlay
     * @param { Object } msg 视频 ;
     * @author pandeng
     */
    spadVideoPlay: function(msg) {
        var videoPlayMsg = Object.assign({}, this.moduleData, this.questionData, {
            event: "VIDEO_PLAY",
            role: "STUDENT",
            tag_code: msg.tag_code || '',
            video_id: msg.video_id || '',
            video_type: msg.video_type || '',
            video_url: msg.video_url || '',
            event_begin: msg.event_begin,
            video_duration: msg.duration || 0
        });
        this.socketChat.recoverChat(() => {
            this.sendEventMessage(this.formatSocketMsg(videoPlayMsg));
            msg.video_id && sendMotionEvent('VIDEO_PLAY', this.metaData, { id: msg.video_id, url: msg.video_url || '' });
        })
    },
    /**
     * 学习机原生播放器-暂停视频
     * @method  spadVideoPause
     * @param { Object } msg 视频 ;
     * @author pandeng
     */
     spadVideoPause: function(msg) {
        var videoPlayMsg = Object.assign({}, this.moduleData, this.questionData, {
            event: "VIDEO_PAUSE",
            role: "STUDENT",
            tag_code: msg.tag_code || '',
            video_id: msg.video_id || '',
            video_type: msg.video_type || '',
            video_url: msg.video_url || '',
            event_begin: msg.event_begin,
            video_duration: msg.duration || 0
        });
        this.sendEventMessage(this.formatSocketMsg(videoPlayMsg));
    },
    /**
     * 学习机原生播放器视频-播放结束
     * @method  spadVideoEnd
     * @param { Object } msg 视频 ;
     * @author pandeng
     */
     spadVideoEnd: function(msg) {
        var videoPlayMsg = Object.assign({}, this.moduleData, this.questionData, {
            event: "VIDEO_END",
            role: "STUDENT",
            tag_code: msg.tag_code || '',
            video_id: msg.video_id || '',
            video_type: msg.video_type || '',
            video_url: msg.video_url || '',
            event_begin: msg.event_begin,
            video_duration: msg.duration || 0
        });
        this.sendEventMessage(this.formatSocketMsg(videoPlayMsg));
    },
    /**
     * 学习机原生播放器视频-关闭视频
     * @method  spadVideoClose
     * @param { Object } msg 视频 ;
     * @author pandeng
     */
     spadVideoClose: function(msg) {
        var videoPlayMsg = Object.assign({}, this.moduleData, this.questionData, {
            event: "VIDEO_CLOSE",
            role: "STUDENT",
            tag_code: msg.tag_code || '',
            video_id: msg.video_id || '',
            video_type: msg.video_type || '',
            video_url: msg.video_url || '',
            event_begin: msg.event_begin,
            video_duration: msg.duration || 0
        });
        this.sendEventMessage(this.formatSocketMsg(videoPlayMsg));
        msg.video_id && sendMotionEvent('VIDEO_CLOSE', this.metaData, { id: msg.video_id, url: msg.video_url || '' });
    },
    /**
     * 学习机原生播放器视频-视频跳过
     * @method  spadVideoClose
     * @param { Object } msg 视频 ;
     * @author pandeng
     */
    spadVideoSkip: function(msg) {
        if (!msg.is_played) {
            var videoPlayMsg = Object.assign({}, this.moduleData, this.questionData, {
                    event: "VIDEO_UNPLAYED_SKIP",
                    role: "STUDENT",
                    tag_code: msg.tag_code || '',
                    video_id: msg.video_id || '',
                    video_type: msg.video_type || '',
                    video_url: msg.video_url || '',
                    video_duration: msg.video_duration,
                    event_begin: new Date().getTime()
            });
            this.sendEventMessage(this.formatSocketMsg(videoPlayMsg));
        } else {
            var videoPlayMsg = Object.assign({}, this.moduleData, this.questionData, {
                event: "VIDEO_PLAYED_SKIP",
                role: "STUDENT",
                tag_code: msg.tag_code || '',
                video_id: msg.video_id || '',
                video_type: msg.video_type || '',
                video_url: msg.video_url || '',
                video_duration: msg.video_duration,
                event_begin: new Date().getTime()
            });
        this.sendEventMessage(this.formatSocketMsg(videoPlayMsg));
        }
    },
    sendEventMessage: function (msg) {
        var _monitor = this;
        try {
            if(msg.event != 'KEEPALIVE'){
                _monitor.preEventName = msg.event
                // if(_monitor.hasStopStudyTime){
                //     _monitor.hasStopStudyTime = false
                //     _monitor.continueStudyTimeFun()
                // }
            }

            _monitor.socketChat.sendMessage(msg)
        } catch (e) {

        }
    },
    stopStudyTimeFun: function () {
        let _self = this
        setTimeout(function () {
            _self.socketChat && _self.socketChat.closeChat();
            window.stopStudyTime && window.stopStudyTime();
        }, 500);
    },
    continueStudyTimeFun: function () {
        let _self = this
        _self.noActionTimeCalc = 0;
        _self.noActionDialogTime = 0
        setTimeout(function () {
            _self.socketChat && _self.socketChat.linkChat();
            window.continueStudyTime && window.continueStudyTime();
        }, 500);
    },
    playAudioNative: function(audioUrl, audioType = 1){
        if (isSSAI()) {
          jsBridgeForSSAI('playAudio', {
            audioUrl,
            audioType,
          });
        }
    },
    stopVideoPlay: function(){
        if (isSSAI()) {
          jsBridgeForSSAI('stopVideoPlay');
        }
    },
    popNoActionDialog: function popNoActionDialog(time) {
        let _self = this;
        if (document.querySelectorAll('.no-action-dialog').length == 0 && document.querySelectorAll('.no-action-dialog-2').length == 0) {
            var pop = document.createElement('div');
            pop.className = 'no-action-dialog';
            pop.id = 'no-action-dialog';
            var ele = '';
            ele = `<div>
                <p class="no-action-tips-1">点击按钮继续学习</p>
                <div class="no-action-progress-bar">
                    <div style="width: 10%; height: 12px; background: #58ABF6; border-radius: 8px" id="no-action-innerbar"></div>
                    <div class="remainder" id="remainder">${300 - time}秒</div>
                </div>
                <a id="continuing-learning" class="continuing-learning">继续学习</a>
            </div>`;
            pop.innerHTML = ele;

            var mask = document.createElement('div');
            mask.className = 'no-action-dialog-mask';
            mask.id = 'no-action-dialog-mask';
            document.body.appendChild(pop);
            document.body.appendChild(mask);
            document.getElementById('continuing-learning').addEventListener('click', function() {
                _self.noActionTimeCalc = 0;
                _self.noActionDialogTime = 0
                document.getElementById('no-action-dialog').remove();
                document.getElementById('no-action-dialog-mask').remove();
            })
            _self.playAudioNative(_self.noActionMusicUrl)
        } else {
            if (document.getElementById('remainder')) {
                document.getElementById('remainder').innerText = (300 - time) + "秒";
                document.getElementById('no-action-innerbar').style.width = (10 - (300 - time)) * 10 + '%';
            }
        }
    },
    removeNoActionDialog: function removeNoActionDialog() {
        if (document.querySelectorAll('.no-action-dialog').length > 0) {
            document.getElementById('no-action-dialog').remove();
            document.getElementById('no-action-dialog-mask').remove();
        }
    },
    popBackStudyDialog: function popBackStudyDialog() {
        const _self = this;
        if (document.querySelectorAll('.no-action-dialog-2').length == 0) {
            _self.stopStudyTimeFun()
            var pop = document.createElement('div');
            pop.className = 'no-action-dialog-2';
            pop.id = 'no-action-dialog-2';
            var ele = '';
            ele = `<div>
                <p class="no-action-tips-1">由于长时间无学习动作，系统自动退出学习，点击按钮重新进入学习</p>
                <a id="continuing-learning-2" class="continuing-learning">回到学习</a>
            </div>`;
            pop.innerHTML = ele;

            var mask = document.createElement('div');
            mask.className = 'no-action-dialog-mask-2';
            mask.id = 'no-action-dialog-mask-2';
            document.body.appendChild(pop);
            document.body.appendChild(mask);
            document.getElementById('continuing-learning-2').addEventListener('click', function() {
                _self.continueStudyTimeFun()
                document.getElementById('no-action-dialog-2').remove();
                document.getElementById('no-action-dialog-mask-2').remove();
            })
        }
    }
}

export default monitor;
